<template>
  <div class="task-upload-item">
    <div class="title">
      <div class="title-text">
        搜索词：{{ item.searchWord }}
        <span class="copy" @click="copy(item.searchWord)">复制</span>
      </div>
      <div class="number">
        上传数量
        <span :class="{ num: true, finish: upPics.length === 3 }"
          >{{ upPics.length }}/3</span
        >
      </div>
    </div>
    <img-upload
      ref="imgUpload"
      :up-pics.sync="upPics"
      :task-data="item"
      :show-pics="upPics"
    >
    </img-upload>
    <input ref="copyBtn" readonly class="copy-input" />
  </div>
</template>

<script>
import imgUpload from './imgUpload.vue'
export default {
  name: 'TaskUploadItem',
  components: { imgUpload },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    model: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // upPics: []
    }
  },
  computed: {
    upPics: {
      get() {
        return this.model
      },
      set(val) {
        this.$emit('update:model', val)
        this.$emit('imgChange')
      }
    }
  },
  // watch: {
  //   'upPics.length'(val) {
  //     this.$emit('update:model', this.upPics)
  //     this.$emit('imgChange')
  //   }
  // },
  methods: {
    copy(val) {
      this.$refs.copyBtn.value = val
      this.$refs.copyBtn.select()
      document.execCommand('copy')
      this.$toast('复制成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.task-upload-item {
  padding: 0.32rem 0.24rem 0.4rem 0.32rem;
  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.48rem;
    .title-text {
      font-size: 0.32rem;
      color: #262626;
      .copy {
        font-size: 0.28rem;
        color: #55a6eb;
        line-height: 0.32rem;
        margin-left: 0.16rem;
      }
    }
    .number {
      font-weight: 400;
      font-size: 0.28rem;
      color: #262626;
      .num {
        font-weight: 500;
        font-size: 0.28rem;
        color: #f45e33;
        &.finish {
          color: #262626;
        }
      }
    }
  }
  .copy-input {
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}
</style>
